import React from 'react'

import Icon from '../../Icons/Icon'
import { type SortColumnProps } from '../../SortColumn/SortColumnProps'
import type StandardTable from '../StandardTable'
import MobileColumnOptions from './MobileColumnOptions'
import styles from './_mobile-table.module.scss'
import { c } from '../../../translations/LibraryTranslationService'
import { Button, SideDrawer } from '../../../module'

type MobileColumnPickerProps = {
  /** Table configuration that will handle column headers and rendering column children. */
  config: React.ComponentProps<typeof StandardTable>['config']
  /** Name by which the active mobile column is stored */
  localStorageName: string
  /** SortColumn's 'sorter' prop - function to update the state of the sortBy prop */
  sort: SortColumnProps['sorter']
  /** This gets passed down to SortColumn's 'active' prop */
  sortBy: SortColumnProps['active']
  /** Function used to update the selected column */
  updateActiveColumn: (header: string) => void
  /** Active column selected */
  activeSecondaryColumn: string
  /** Ref to keep track of scoll position */
  scrollPositionRef: React.Ref<HTMLDivElement>
  /** Optional class to apply to main column */
  mainColumnClassName?: string
}

const MobileColumnPicker = ({
  config,
  localStorageName,
  sort,
  sortBy,
  updateActiveColumn,
  activeSecondaryColumn,
  scrollPositionRef,
  mainColumnClassName,
}: MobileColumnPickerProps): React.JSX.Element => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)
  return (
    <>
      <Button
        onClick={() => setIsDrawerOpen(true)}
        as='unstyled'
        className={styles.select}
      >
        <div
          ref={scrollPositionRef}
          className={`${styles.mainColumnContainer} ${mainColumnClassName || ''}`}
        >
          <span>
            {c('mainColumn')}{' '}
            <span className={styles.boldFont}>{activeSecondaryColumn}</span>
          </span>
          <Icon icon='carat' iconSize='8px' className={styles.caratIcon} />
        </div>
      </Button>

      <SideDrawer
        isOpen={isDrawerOpen}
        closeCallout={() => setIsDrawerOpen(false)}
        headerContent={c('selectMainColumn')}
      >
        <MobileColumnOptions
          config={config}
          localStorageName={localStorageName}
          sort={sort}
          setActiveColumn={(header) => {
            updateActiveColumn(header)
          }}
          sortBy={sortBy}
          activeSecondaryColumn={activeSecondaryColumn}
          drawerCloseCallout={setIsDrawerOpen}
        />
      </SideDrawer>
    </>
  )
}

export default MobileColumnPicker
